/**
 * Store: Market switcher
 * -----------------------------------------------------------------------------
 *
 */
export default {
  namespaced: true,

  state: () => ({
    localization: {
      countries: [],
      languages: [],
    },
    country: {
      name: '',
      code: '',
    },
    language: {
      name: '',
      code: '',
    },
  }),

  mutations: {

    /**
     * Set localization.
     * @param {Object} localization - Shopify localization.
     */
    SET_LOCALIZATION(state, localization) {
      state.localization = localization
    },

    /**
     * Set country.
     * @param {Object} country - Shopify localization.country.
     */
    SET_COUNTRY(state, country) {
      state.country = country
    },

    /**
     * Set language.
     * @param {Object} language - Shopify localization.language.
     */
    SET_LANGUAGE(state, language) {
      state.language = language
    },
  },

  actions: {

    /**
     * Set localization.
     * @param {Object} localization - Shopify localization.
     */
    setLocalization({ commit }, localization) {
      commit('SET_LOCALIZATION', localization)
    },

    /**
     * Set country.
     * @param {String} country - Shopify localization.country.
     */
    setCountry({ commit }, country) {
      commit('SET_COUNTRY', country)
    },

    /**
     * Set language.
     * @param {String} language - Shopify localization.language.
     */
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
  },
}
